// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__Fyhg7","input":"Input_input__VfYaU","label":"Input_label__g0+03","error":"Input_error__JCXIZ"};